import { flex } from '@/styles/minix';
import styled from 'styled-components';

export const SystemWrap = styled.div`
	margin: auto;
	padding-top: 140px;
	position: relative;
	.switch-button {
		position: absolute;
		top: 30px;
		right: 30px;
		height: 38px;
		background: #f4f5f7;
		border-radius: 2px;
		border: 1px solid #dfe1e6;
		text-align: center;
		line-height: 38px;
		cursor: pointer;
		color: #172b4d;
		font-size: 16px;
		padding-left: 16px;
		padding-right: 18px;
		> img {
			margin-left: 8px;
			vertical-align: baseline;
		}
	}
`;
export const HeaderCSS = styled.div`
	${flex('row', 'center')}
	.title {
		font-size: 40px;
		font-weight: 600;
		color: #172b4d;
		margin-left: 10px;
	}
`;
